// paths cannot start with a slash
export const PAGE_ROUTES = {
  ROOT: {
    SUBROUTES: {
      LIST: 'list',
    },
    CAMPAIGN_SUBROUTES: {
      DETAILS: (campaignId: string) => `${campaignId}/details`,
      HISTORY: (campaignId: string) => `${campaignId}/history`,
      LINKACTIVITY: (attribute_key: string, attribute_value: string) =>
        `link-activity/${attribute_key}/${attribute_value}`,
    },
    TEMPLATE: 'template',
    TEMPLATE_SUBROUTES: {
      EDIT: (templateID: string) => `template/${templateID}/edit`,
      NEW: 'template/new',
    },
    SMS: {
      TEMPLATE: 'sms/template',
      EDIT: (templateID: string) => `sms/template/${templateID}/edit`,
    },
  },
};
